import React from 'react';
import { CellScope, Table, TableBody, TableCell, TableHead, TableRow } from '../../components/organisms/Table';
import { shortcuts } from './shortCuts';
import { EditorHelpShortcutRow } from '../../components/molecules/Form/components/Editor';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

/**
 * Block explaining AccessKeys in the Help section of the portal.
 */
function AccessKeys() {
  const { t } = useSonTranslation('AccessKeys');
  return (
    <div className="wysiwyg">
      <h2>{t('headline')}</h2>
      <p>{t('textAccesskeys')}</p>
      <p>{t('textAccesskeysDisable')}</p>
      <Table caption={t('accesskeysCaption')}>
        <TableHead>
          <TableRow>
            <TableCell>{t('tableHeadAction')}</TableCell>
            <TableCell>{t('tableHeadShortcut')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {shortcuts(t).map(item => (
            <EditorHelpShortcutRow key={item.action} action={item.action} shortcut={item.shortcut} />
          ))}
        </TableBody>
      </Table>
      <p>{t('textOperatingSystem')}</p>
      <Table caption={t('shortCutsBrowser')}>
        <TableHead>
          <TableRow>
            <TableCell isTableData />
            <TableCell>
              <span lang="en">{t('environment.windows')}</span>
            </TableCell>
            <TableCell>
              <span lang="en">{t('environment.linux')}</span>
            </TableCell>
            <TableCell>
              <span lang="en">{t('environment.macOs')}</span>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell isTableHead scope={CellScope.ROW}>
              <span lang="en">{t('browser.chromeAndEdge')}</span>
            </TableCell>
            <TableCell>
              <kbd>{t('keyboard.alt')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
            <TableCell>
              <kbd>{t('keyboard.alt')}</kbd> + <kbd>{t('keyboard.shift')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
            <TableCell>
              <kbd lang="en">{t('keyboard.control')}</kbd> + <kbd>{t('keyboard.option')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell isTableHead scope={CellScope.ROW}>
              <span lang="en">{t('browser.firefox')}</span>
            </TableCell>
            <TableCell>
              <kbd>{t('keyboard.alt')}</kbd> + <kbd>{t('keyboard.shift')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
            <TableCell>
              <kbd>{t('keyboard.alt')}</kbd> + <kbd>{t('keyboard.shift')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
            <TableCell>
              <kbd lang="en">{t('keyboard.control')}</kbd> + <kbd>{t('keyboard.option')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell isTableHead scope={CellScope.ROW}>
              <span lang="en">{t('browser.safari')}</span>
            </TableCell>
            <TableCell>
              <kbd>{t('keyboard.alt')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
            <TableCell>{'\u2010'}</TableCell>
            <TableCell>
              <kbd lang="en">{t('keyboard.control')}</kbd> + <kbd>{t('keyboard.option')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell isTableHead scope={CellScope.ROW}>
              <span lang="en">{t('browser.opera')}</span>
            </TableCell>
            <TableCell>
              <kbd>{t('keyboard.alt')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
            <TableCell>
              <kbd lang="en">{t('keyboard.ctrl')}</kbd> + <kbd>{t('keyboard.alt')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
            <TableCell>
              <kbd lang="en">{t('keyboard.control')}</kbd> + <kbd>{t('keyboard.option')}</kbd> + <kbd>{t('key')}</kbd>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
}

export const AccessKeysBlock = asBlock(AccessKeys, BlockType.accesskeys);
